import { render, staticRenderFns } from "./GamePeriodData.vue?vue&type=template&id=c5a21284&scoped=true&"
import script from "./GamePeriodData.vue?vue&type=script&lang=js&"
export * from "./GamePeriodData.vue?vue&type=script&lang=js&"
import style0 from "./GamePeriodData.vue?vue&type=style&index=0&id=c5a21284&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a21284",
  null
  
)

export default component.exports